import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import Activity from "@mapmycustomers/shared/types/entity/Activity";

import { RootState } from "@app/store/rootReducer";

import { getSelected } from "../../store/selectors";

import BulkActions from "./component/BulkActions";
import styles from "./SelectBar.module.scss";

interface Props {
  selected: Activity[];
}

const SelectBar: React.FC<Props> = ({ selected }) => {
  const intl = useIntl();

  if (selected.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {intl.formatMessage(
          {
            id: "activity.listView.selectBar.selectedActivities",
            defaultMessage: "{count} {count, plural, one {activity} other {activities}} selected",
            description: "Select activities bar title",
          },
          {
            count: selected.length,
          }
        )}
      </div>
      <BulkActions className={styles.bulkActions} selected={selected} />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  selected: getSelected(state),
});

export default connect(mapStateToProps)(SelectBar);
